import React,{useEffect} from "react";

const ThankYouStudyabroad = ({destinationUrl}) => {
  useEffect(()=>{
    setTimeout(()=>{
      window.location.href = destinationUrl;
    },5000)
  },[destinationUrl])
  return (
    <section className="thank-you" style={{padding: '0', margin:'0'}}>
        <div className="container_full">
            <div className="thanks_content">
                <a href={destinationUrl} className="cross_close">X</a>
                <h2><strong>Thank You</strong> </h2>
                <h2>Your Preferences have been <strong> Submited</strong>
                </h2>
                <div className="btm_block btm_block_desktop">
                    <img src={require("../../assets/images/studyabroad-thankyou-desktop.gif")} alt="" />
                </div>

                <div className="btm_block btm_block_mobile">
                <img src={require("../../assets/images/studyabroad-thankyou-mobile.gif")} alt="" />
                </div>
            </div>
        </div>
    </section>  
  );
};

export default ThankYouStudyabroad;
